import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
const COLOR_MAP = {
  blue: "text-blue-600 bg-blue-100",
  green: "text-green-600 bg-green-100",
  red: "text-red-600 bg-red-100",
  indigo: "text-indigo-600 bg-indigo-100",
  pink: "text-pink-600 bg-pink-100",
};

const StudentCountTable = () => {
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    const sessionId = localStorage.getItem("currentSessionId");

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/students/students/count-summary`, {
        params: { sessionId },
      })
      .then((res) => setCounts(res.data))
      .catch((err) => console.error(err));
  }, []);

  if (!counts) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-xl shadow-sm p-5 h-[110px] animate-pulse"
          />
        ))}
      </div>
    );
  }

  const stats = [
    { label: "Total Students", value: counts.active, color: "blue", icon: "fa-users" },
    { label: "Boys", value: counts.boys, color: "indigo", icon: "fa-male" },
    { label: "Girls", value: counts.girls, color: "pink", icon: "fa-female" },
  ];

 return (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
    {stats.map((item, index) => (
      <Link key={index} to="/student-report/details" className="flex">
  <div className="relative bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center justify-between min-h-[110px] w-full hover:shadow-md hover:scale-[1.02] transition cursor-pointer">

    {/* 🔹 View text */}
    <span className="absolute top-3 right-4 text-xs font-medium text-blue-500 hover:text-blue-700">
      View →
    </span>

    <div>
      <p className="text-sm text-gray-500 font-medium">
        {item.label}
      </p>
      <h3
        className={`text-3xl font-bold ${
          COLOR_MAP[item.color].split(" ")[0]
        } mt-1`}
      >
        {item.value}
      </h3>
    </div>

    <div
      className={`w-12 h-12 rounded-full flex items-center justify-center text-xl ${COLOR_MAP[item.color]}`}
    >
      <i className={`fas ${item.icon}`} />
    </div>

  </div>
</Link>

    ))}
  </div>
);
};

export default StudentCountTable;
